// Define the interface for the bookisbn object
interface BookISBN {
    title?: string;
    slug?: string;
    author?: string;
    thumbnailMedium?: string;
  }

  /**
   * Creates an SEO object for a book based on its bookisbn data.
   * @param bookisbn - The bookisbn object containing book details.
   * @returns The SEO object with title, slug, description, ogTitle, and img properties.
   */
  export function createBookSeo(bookisbn: BookISBN): {
    title: string;
    slug: string;
    description: string;
    ogTitle: string;
    img: string;
  } {
    // Fallback values for missing bookisbn properties
    const title = bookisbn?.title || 'Bez tytułu';
    const slug = bookisbn?.slug || '';
    const author = bookisbn?.author || 'nieznany autor';
    const thumbnailMedium = bookisbn?.thumbnailMedium || null;

    // Fallback image if thumbnailMedium is not available
    const fallbackImage = require('@/assets/images/book_cover_unavailable.webp').default.src;

    return {
      title: `Egzemplarze książki ${title}`,
      slug: `/book/${slug}`,
      description: `Mamy przynajmniej jeden egzemplarz a ${author} na pewno cieszyłby się jeśli dodasz do nas swój!`,
      ogTitle: `Dodaj swój egzemplarz książki ${title}.`,
      img: thumbnailMedium || fallbackImage,
    };
  }